import { SVGProps } from 'react';

export const ClockOutLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="38"
      height="45"
      viewBox="0 0 38 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.7033 10.9333L33.7304 7.90617L36.6762 10.852L33.6491 13.8791C36.6403 17.6232 38.0843 22.3705 37.6847 27.146C37.285 31.9216 35.072 36.3628 31.5001 39.5577C27.9282 42.7525 23.2686 44.4585 18.4782 44.3251C13.6879 44.1917 9.13037 42.2292 5.74175 38.8406C2.35314 35.452 0.390624 30.8945 0.257268 26.1041C0.123913 21.3137 1.82984 16.6541 5.02469 13.0822C8.21954 9.51034 12.6608 7.29732 17.4363 6.89767C22.2119 6.49801 26.9592 7.94207 30.7033 10.9333ZM18.9991 40.1666C20.9142 40.1666 22.8106 39.7894 24.5799 39.0565C26.3492 38.3236 27.9569 37.2494 29.3111 35.8952C30.6653 34.541 31.7395 32.9334 32.4724 31.1641C33.2052 29.3947 33.5824 27.4984 33.5824 25.5833C33.5824 23.6681 33.2052 21.7718 32.4724 20.0025C31.7395 18.2331 30.6653 16.6255 29.3111 15.2713C27.9569 13.9171 26.3492 12.8429 24.5799 12.11C22.8106 11.3771 20.9142 10.9999 18.9991 10.9999C15.1314 10.9999 11.422 12.5364 8.68713 15.2713C5.95223 18.0062 4.41577 21.7155 4.41577 25.5833C4.41577 29.451 5.95223 33.1603 8.68713 35.8952C11.422 38.6301 15.1314 40.1666 18.9991 40.1666ZM16.9158 15.1666H21.0824V27.6666H16.9158V15.1666ZM10.6658 0.583252H27.3324V4.74992H10.6658V0.583252Z"
        fill="#F9AA1A"
      />
    </svg>
  );
};
